// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"146c64f4","360":"ef7be188","501":"1e4aa384","577":"d8302739","667":"9ec2936b","738":"5d64afb4","749":"47b7db75","937":"9dbc1c0a"}[chunkId] + ".chunk.js";
};